import React from 'react'
import { Outlet } from 'react-router'

const RightsholderCatalogLayout = () => (
    <>
        <title>Catalog</title>
        <Outlet />
    </>
)

export default RightsholderCatalogLayout
